import { getElementChild, getElements } from '../Utility/Dom'

class Accordion {
  readonly details: [] | NodeListOf<HTMLElement> = []
  private readonly TRANSITION_DURATION: number = 550

  constructor() {
    this.details = getElements('accordion-details')
  }

  init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.details.forEach((el: HTMLElement): void => {
      const details = el as HTMLDetailsElement

      getElementChild(details, 'accordion-click-area')?.addEventListener('click', (e: Event): void => {
        e.preventDefault()

        if (details.open) {
          this.close(details)
        } else {
          details.open = true
        }
      })
    })

    document.addEventListener('DOMContentLoaded', this.setDetailsHeight.bind(this))
  }

  private close = (details: HTMLDetailsElement): void => {
    let timer: null | ReturnType<typeof setTimeout> = null

    const finish = (): void => {
      if (timer) clearTimeout(timer)
      details.open = false
      details.style.removeProperty('height')
    }

    details.style.height = 'var(--expanded)'

    requestAnimationFrame((): void => {
      details.style.height = 'var(--collapsed)'

      details.addEventListener(
        'transitionend',
        (e: TransitionEvent): void => {
          if (e.propertyName === 'height') finish()
        },
        { once: true }
      )

      timer = setTimeout(finish, this.TRANSITION_DURATION)
    })
  }

  private setDetailsHeight(): void {
    const resizeObserver = new ResizeObserver(entries => entries.forEach(entry => {
      const details = entry.target as HTMLDetailsElement

      if (!details.open) {
        details.removeAttribute('style')
        this.setHeight(details)
        this.setHeight(details, true)
        details.open = false
      }
    }))

    this.details.forEach((details: HTMLElement): void => {
      resizeObserver.observe(details as HTMLDetailsElement)

      if (details.hasAttribute('open')) {
        this.setHeight(details as HTMLDetailsElement)
        this.setHeight(details as HTMLDetailsElement, true)
      }
    })
  }

  private setHeight = (details: HTMLDetailsElement, isOpen = false): void => {
    details.open = isOpen
    const rect = details.getBoundingClientRect()
    details.style.setProperty(isOpen ? '--expanded' : '--collapsed', `${rect.height}px`)
  }
}

const accordion = new Accordion()
accordion.init()
